import React from 'react'
import styled from 'styled-components'


const Spacer = ({ height = "20px", bg = "transparent", minh = "auto", mHeight = "20px" }) => {

    return (
        <Wrap $height={height} $bg={bg} $minh={minh} $mHeight={mHeight} />
    )
}

export default Spacer


const Wrap = styled.div`
min-height: ${(props) => (props.$minh)}; 
height: ${(props) => (props.$mHeight)}; 
display: block;
background: ${(props) => (props.$bg)};   

@media(width > 768px) {

    height: ${(props) => (props.$height)}; 
    
    }

`